import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify'; 
import moment from 'moment';
import { Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { clearApprovedTimeEntries } from '../../../store/actions/timesheet/timesheetActions';
import ReportInfoHeader from './ReportInfoHeader';
import GroupCard from './GroupCard';
import BudgetRevenueBreakdown from './BudgetRevenueBreakdown';
import ActualRevenueBreakdown from './ActualRevenueBreakdown';
import VarianceRevenueBreakdown from './VarianceRevenueBreakdown';
import VariancePercentage from './VariancePercentage';
import RevenueFields from './RevenueFields';

import { getProject, 
  getProjectsJSON, 
  fetchProjects, 
  resetProject, 
  fetchChildrenProjects, 
  resetAllProjectCosting, 
  APPROVED } from '../../../store/actions/projects/projectsActions';
import { fetchPlatforms } from '../../../store/actions/platforms/platformActions';
import { fetchProjectScope, PROFIT_NET_OF_TAX_MULTIPLIER } from  '../../../store/actions/projects/projectCostingActions';
import { resetTimeEntriesPerProject } from '../../../store/actions/timesheet/timesheetActions';
import { refreshReports, 
  mergeBudgetRevenueDetails, 
  mergeActualRevenueDetails } from '../../../store/actions/reports/reportsActions';
import { toggleShowAlert, ERROR_ALERT } from '../../../store/actions/commonActions';

import PageTitle from '../../../common/PageTitle';
import ExportReport from '../ExportReport';
import { PROJECT_SPONSOR } from '../../../store/actions/users/usersActions';
import { formatDate } from '../../../common/Utilities';

class ProfitabilityPerProject extends Component {

  constructor(props) {
    super(props);
    this.showTable = false; 
    this.projectId = 0;
    this.startDate = new Date(moment().subtract(1, 'weeks'));
    this.endDate = new Date();
    this.startMaxDate = this.startDate;
    this.endMinDate = this.endDate;
  }
  
  componentDidMount() {
    this.props.fetchPlatforms();

    const roleId = Cache.getItem('roleId');
    let filters = {
      status: APPROVED,
      is_disabled: 0 
    }

    if (roleId === PROJECT_SPONSOR) {
      const userId = Cache.getItem('userId');
      filters.project_sponsor = userId;
    }

    this.props.fetchProjects(filters);
  }
  
  displayProjectDropDown = () => {

    let projectsJSON = this.props.getProjectsJSON({includeGenAdmin: false}, true);
    
    //generate project arrays 
    this.projects = projectsJSON.map(project => { return project.value; });

    const selectClass = 'projectSelect';

    return (
        <Select
          className={selectClass}
          classNamePrefix={selectClass}
          size="sm"
          onChange={(selectedOption) => {
            this.projectId = selectedOption.value;

            const projects = this.props.projects.projects;
            const project = projects.filter(project => project.id === this.projectId).shift();

            this.startDate = new Date(project.start_date);
            this.props.refreshReports();
          }}
          options={projectsJSON}
        />
    )
  }

  displayDatepicker = () => {
    return (
      <Row>
        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
          <DatePicker
            placeholderText="Start Date"
            minDate={this.minDate}
            maxDate={this.maxDate}
            onChange={(date) => {
              this.startDate = date;
              this.endMinDate = date;
              this.props.refreshReports();
            }} 
            selected={this.startDate}
            
          /> 
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} xl={6}>
          <DatePicker
            placeholderText="End Date"
            minDate={this.minDate}
            onChange={(date) => {
              this.endDate = date;
              this.startMaxDate = date;
              this.props.refreshReports();
            }} 
            selected={this.endDate}
          /> 
        </Col>
      </Row>
    )
  }

  displayGenerateButton = () => {
    return (
      <Button
        id={this.buttonId}
        onClick={()=>{
          if (!this.projectId) {
            this.props.toggleShowAlert(true, ERROR_ALERT, 'Please select a project.');
            return false;
          }
          
          this.showTable = true;
          this.props.clearApprovedTimeEntries();
          this.props.resetProject();
          this.props.resetAllProjectCosting();
          this.props.resetTimeEntriesPerProject();
          this.props.fetchChildrenProjects(this.projectId, this.startDate, this.endDate);
        }}
      >
        Generate Report
      </Button>
    )
  }

  generateGroupCards = () => {
    this.groups = [
      {groupId: 1, groupLabel: 'DELIVERY STANDARD'}, 
      {groupId: 2, groupLabel: 'DELIVERY PREMIUM'}, 
      {groupId: 3, groupLabel: 'TECHNICAL STANDARD'}, 
      {groupId: 4, groupLabel: 'TECHNICAL PREMIUM'}
    ];

    this.bandGroups = [
      'A', 
      'B', 
      'C', 
      'D', 
      'E'
    ];

    let budgetScopes = this.props.projects.allProjScoping;
    let timeEntriesPerBand = this.props.timesheets.timeEntriesPerProject;
    let mergeProjectScopes = [];
    let mergeTimeEntries = [];

    //let's merge project scopes across all projects that are belong to the family
    this.groups.forEach(group => {
      let objMergeTimeEntries = {};
      let hasTimeEntries = false;

      this.bandGroups.forEach(bandGroup => {
        let totalManHours = 0;
        let totalMandays = 0;
        let totalActualHours = 0;
        let actualBandGroup = '';
        let hasScope = false;

        budgetScopes.length  && budgetScopes.filter(data => {
          if (data.platform_id === group.groupId && data.band_group === bandGroup) {
            return data;
          }
          return false;
        }).forEach(budgetScope => {
          if (budgetScope) {
            hasScope = true;
            bandGroup = budgetScope.band_group;
            totalManHours += budgetScope.manhours;
            totalMandays += budgetScope.mandays;
          }
        }) 

        //merge time entries per band across all projects that are belong to the family
        timeEntriesPerBand.length && timeEntriesPerBand.filter(data => {
          if (data.group === group.groupId) {
            return data;
          }
          return false;
        }).forEach(timeEntries => {
          if (timeEntries) {
            hasTimeEntries = true;
            actualBandGroup = 'band' + bandGroup;
            totalActualHours += timeEntries[actualBandGroup];
          }
        });

        objMergeTimeEntries[actualBandGroup] = totalActualHours;

        if (hasScope) {
          mergeProjectScopes.push({
            platform_id: group.groupId, 
            band_group: bandGroup, 
            mandays: totalMandays, 
            manhours: totalManHours
          })
        }
      })

      if (hasTimeEntries) {
        objMergeTimeEntries.group = group.groupId;
        mergeTimeEntries.push(objMergeTimeEntries);
      }
    })

    let groupCards = this.groups ? this.groups.map((group, key) => {
      return <GroupCard key={key} 
        groupId={group.groupId} 
        groupLabel={group.groupLabel} 
        bands={this.bandGroups} 
        timeEntriesPerBand={mergeTimeEntries}
        budgetScopes={mergeProjectScopes} />
    }) : ''

    return groupCards
  }

  budgetRevenueBreakdown = () => {
    const parentProject = this.props.projects.project;
    const childrenProjects = this.props.projects.childrenProjects;
    
    let allProjects = [];
    if (parentProject && childrenProjects) {
      allProjects = childrenProjects.concat(parentProject);
    }

    //Get total budget revenue, fully loaded cost, unloaded, other cost, etc.
    let budgetBreakdown = {} 

    let result = mergeBudgetRevenueDetails(allProjects);

    if (result) {
      budgetBreakdown.totalRevenue = +result.totalRevenue;
      budgetBreakdown.totalFullyLoadedCost = +result.totalFullyLoadedCost;
      budgetBreakdown.totalUnloadedCost = +result.totalUnloadedCost;
      budgetBreakdown.totalExternalCost = +result.totalExternalCost;
      budgetBreakdown.totalCost = +result.totalFullyLoadedCost + result.totalUnloadedCost + result.totalExternalCost;
      budgetBreakdown.profitBeforeTax = +result.totalRevenue - (+budgetBreakdown.totalCost);
      budgetBreakdown.profitNetofTax = +budgetBreakdown.profitBeforeTax * PROFIT_NET_OF_TAX_MULTIPLIER
    }

    this.budgetBreakdown = budgetBreakdown;

    return (
      <BudgetRevenueBreakdown budgetBreakdown={this.budgetBreakdown} />
    )
  }

  actualRevenueBreakdown = () => {
    //Get total budget revenue, fully loaded cost, unloaded, other cost, etc.
    const parentProject = this.props.projects.project;
    const childrenProjects = this.props.projects.childrenProjects;
    
    let allProjects = [];
    if (parentProject && childrenProjects) {
      allProjects = childrenProjects.concat(parentProject);
    }

    if (!allProjects.length) {
      return '';
    }

    const timeEntries = this.props.timesheets.approvedTimeEntries || [];

    let result = mergeActualRevenueDetails(allProjects, timeEntries);

    let actualBreakdown = {} 

    actualBreakdown.totalRevenue = +result.totalRevenue;
    actualBreakdown.totalFullyLoadedCost = +result.totalFullyLoadedCost;
    actualBreakdown.totalUnloadedCost = +result.totalUnloadedCost;
    actualBreakdown.totalExternalCost = +result.totalExternalCost;
    actualBreakdown.totalCost = +result.totalFullyLoadedCost + +result.totalUnloadedCost + +result.totalExternalCost;
    actualBreakdown.profitBeforeTax = +result.totalRevenue - +actualBreakdown.totalCost;
    actualBreakdown.profitNetofTax = +actualBreakdown.profitBeforeTax * PROFIT_NET_OF_TAX_MULTIPLIER;

    this.actualBreakdown = actualBreakdown;

    return (
      <ActualRevenueBreakdown actualBreakdown={actualBreakdown} />
    )
  }

  varianceRevenueBreakdown = () => {
    const budgetBreakdown = this.budgetBreakdown;
    const actualBreakdown = this.actualBreakdown;

    let varianceBreakdown = {}

    varianceBreakdown.varianceRevenue = +actualBreakdown.totalRevenue - +budgetBreakdown.totalRevenue;
    varianceBreakdown.varianceFullyLoadedCost = +budgetBreakdown.totalFullyLoadedCost - +actualBreakdown.totalFullyLoadedCost;
    varianceBreakdown.varianceUnloadedCost = +budgetBreakdown.totalUnloadedCost - +actualBreakdown.totalUnloadedCost;
    varianceBreakdown.varianceExternalCost = +budgetBreakdown.totalExternalCost - +actualBreakdown.totalExternalCost;
    varianceBreakdown.varianceTotalCost = +budgetBreakdown.totalCost - +actualBreakdown.totalCost;
    varianceBreakdown.varianceProfitBeforeTax = +actualBreakdown.profitBeforeTax - +budgetBreakdown.profitBeforeTax;
    varianceBreakdown.varianceProfitNetofTax = +actualBreakdown.profitNetofTax - +budgetBreakdown.profitNetofTax;

    this.varianceBreakdown = varianceBreakdown;

    return (
      <VarianceRevenueBreakdown varianceBreakdown={varianceBreakdown} />
    )
  }

  variancePercentage = () => {
    return (
      <VariancePercentage budgetBreakdown={this.budgetBreakdown} varianceBreakdown={this.varianceBreakdown} />
    )
  }

  displayProfitabilityReport = () => {
    if (!this.showTable) {
      return '';
    }

    return (
      <>
        <Row className="mt-5">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <ReportInfoHeader project={this.props.projects.project} startDate={this.startDate} endDate={this.endDate} />
          </Col>
        </Row>
        <Row>
          <Col>
            { this.generateGroupCards() }
          </Col>
        </Row>
        <Row className="mt-5">
          <Col xs={2} sm={2} md={2} lg={2} xl={2}></Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-center"><b>Budget</b></Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-center"><b>Actual</b></Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-center"><b>Variance</b></Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-center"><b>Variance%</b></Col>
        </Row>
        <Row>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} className="align-left">
            <RevenueFields />
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            { this.budgetRevenueBreakdown() }
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            { this.actualRevenueBreakdown() }
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            { this.varianceRevenueBreakdown() }
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} xl={2}>
            { this.variancePercentage() }
          </Col>
        </Row>
      </>
    )
  }

  /**
   * TODO: Export to CSV
   */
  renderExportFile = () => {
    
    if (!this.showTable) {
      return '';
    }

    this.groups = [
      {groupId: 1, groupLabel: 'DELIVERY STANDARD'}, 
      {groupId: 2, groupLabel: 'DELIVERY PREMIUM'}, 
      {groupId: 3, groupLabel: 'TECHNICAL STANDARD'}, 
      {groupId: 4, groupLabel: 'TECHNICAL PREMIUM'}
    ];

    let bandGroups = [
      'Band A', 
      'Band B', 
      'Band C', 
      'Band D', 
      'Band E',
    ];

    bandGroups.push('Total');

    const project = this.props.projects.project;

    let projectName = '';
    let projectCode = '';
    let clientName = '';
    let projManagerName = '';
    
    if (Object.keys(project).length) {
      projectName = project.project_name;
      projectCode = project.project_code;
      
      if (typeof(project.client) !== "undefined") {
        const client = project.client;
        if (client && Object.keys(client).length) {
          clientName = client.client_name;
        }
      }

      if (typeof(project.project_manager) !== "undefined") {
        const projectManager = project.project_manager;
        if (projectManager && Object.keys(projectManager).length) {
          projManagerName = projectManager.first_name + " " + projectManager.last_name;
        }
      }
    }

    this.exportReportHeader = [
      ['Profitability Analysis'], 
      ['Client Name', clientName], 
      ['Project Name', projectName], 
      ['Project Code', projectCode], 
      ['MS Manager', projManagerName], 
      ['Start Date',formatDate(new Date(project.start_date))],
      ['End Date',formatDate(new Date(project.end_date))],
      ['Report Filter Date',`${formatDate(this.startDate)} - ${formatDate(this.endDate)}`],
      [],
      []
    ];
    
    let allGroup = [];
    let revenueBreakdown = [];

    let deliveryStandardHeader = [
      [this.groups[0].groupLabel, '', '', 'BUDGET', '', '', '', '', 'ACTUAL', '', '', '', '', 'VARIANCE'], 
    ];

    let deliveryPremiumHeader = [
      [this.groups[1].groupLabel, '', '', 'BUDGET', '', '', '', '', 'ACTUAL', '', '', '', '', 'VARIANCE'], 
    ];

    let technicalStandardHeader = [
      [this.groups[2].groupLabel, '', '', 'BUDGET', '', '', '', '', 'ACTUAL', '', '', '', '', 'VARIANCE'], 
    ];
    let technicalPremiumHeader = [
      [this.groups[3].groupLabel, '', '', 'BUDGET', '', '', '', '', 'ACTUAL', '', '', '', '', 'VARIANCE'], 
    ];

    let valuesHeaders = ['', '', 
        'Mandays', 'Manhours', 'Percentage', 'FTE',
        '', 
        'Mandays', 'Manhours', 'Percentage', 'FTE', 
        '', 
        'Mandays', 'Manhours', 'Percentage', 'FTE'
    ];

    deliveryStandardHeader.push(valuesHeaders);
    deliveryPremiumHeader.push(valuesHeaders);
    technicalStandardHeader.push(valuesHeaders);
    technicalPremiumHeader.push(valuesHeaders);

    let deliveryStandard = [...deliveryStandardHeader];

    let deliveryPremium = [...deliveryPremiumHeader];

    let technicalStandard = [...technicalStandardHeader];

    let technicalPremium = [...technicalPremiumHeader];

    
    this.groups.length && this.groups.forEach(group => {
      let budgetManhours = Array.from(document.querySelectorAll('.budget-manhours-' + group.groupId));
      let budgetMandays = Array.from(document.querySelectorAll('.budget-mandays-' + group.groupId));
      let budgetPercentanges = Array.from(document.querySelectorAll('.budget-percentage-' + group.groupId));
      let budgetFTEs = Array.from(document.querySelectorAll('.budget-fte-' + group.groupId));

      let actualManhours = Array.from(document.querySelectorAll('.actual-manhours-' + group.groupId));
      let actualMandays = Array.from(document.querySelectorAll('.actual-mandays-' + group.groupId));
      let actualPercentanges = Array.from(document.querySelectorAll('.actual-percentage-' + group.groupId));
      let actualFTEs = Array.from(document.querySelectorAll('.actual-fte-' + group.groupId));

      let varianceManhours = Array.from(document.querySelectorAll('.variance-manhours-' + group.groupId));
      let varianceMandays = Array.from(document.querySelectorAll('.variance-mandays-' + group.groupId));
      let variancePercentanges = Array.from(document.querySelectorAll('.variance-percentage-' + group.groupId));
      let varianceFTEs = Array.from(document.querySelectorAll('.variance-fte-' + group.groupId));

      bandGroups.forEach((bandGroup, i) => {
        let row = [];
        row.push(bandGroup);
        row.push('');
        row.push(typeof(budgetMandays[i]) !== "undefined" ? budgetMandays[i].innerHTML : '');
        row.push(typeof(budgetManhours[i]) !== "undefined" ? budgetManhours[i].innerHTML : '');
        row.push(typeof(budgetPercentanges[i]) !== "undefined" ? budgetPercentanges[i].innerHTML : '');
        row.push(typeof(budgetFTEs[i]) !== "undefined" ? budgetFTEs[i].innerHTML : '');

        row.push('');

        row.push(typeof(actualMandays[i]) !== "undefined" ? actualMandays[i].innerHTML : '');
        row.push(typeof(actualManhours[i]) !== "undefined" ? actualManhours[i].innerHTML : '');
        row.push(typeof(actualPercentanges[i]) !== "undefined" ? actualPercentanges[i].innerHTML : '');
        row.push(typeof(actualFTEs[i]) !== "undefined" ? actualFTEs[i].innerHTML : '');
        row.push('');

        row.push(typeof(varianceMandays[i]) !== "undefined" ? varianceMandays[i].innerHTML : '');
        row.push(typeof(varianceManhours[i]) !== "undefined" ? varianceManhours[i].innerHTML : '');
        row.push(typeof(variancePercentanges[i]) !== "undefined" ? variancePercentanges[i].innerHTML : '');
        row.push(typeof(varianceFTEs[i]) !== "undefined" ? varianceFTEs[i].innerHTML : '');

        switch(group.groupId) {
          case 1: 
            deliveryStandard.push(row);
            break;
          case 2: 
            deliveryPremium.push(row);
            break;
          case 3: 
            technicalStandard.push(row);
            break;
          case 4:
            technicalPremium.push(row);
            break;
          default:
            break;
        }
      })
    })
    
    allGroup.push(deliveryStandard, deliveryPremium, technicalStandard, technicalPremium);

    this.allGroupDetails = allGroup;

    let revenue = ['Revenue', ''];
    let fullyLoadedCost = ['Fully Loaded Cost', '', ];
    let unloadedCost = ['Unloaded Cost', ''];
    let externalCost = ['Other Cost', ''];
    let totalCost = ['Total Cost', ''];
    let profitBeforeTax = ['Profit Before Tax', ''];
    let profitNetAfterTax = ['Profit Net after Tax', ''];

    const totalRevenue = Array.from(document.querySelectorAll('.breakdown-total-revenue'));
    const totalFullyLoadedCost = Array.from(document.querySelectorAll('.breakdown-total-fully-loaded-cost'));
    const totalUnloadedCost = Array.from(document.querySelectorAll('.breakdown-total-unloaded-cost'));
    const totalExternalCost = Array.from(document.querySelectorAll('.breakdown-total-external-cost'));
    const sumTotalCost = Array.from(document.querySelectorAll('.breakdown-total-cost'));
    const totalProfitBeforeTax = Array.from(document.querySelectorAll('.breakdown-total-profit-before-tax'));
    const totalProfitNetAfterTax= Array.from(document.querySelectorAll('.breakdown-total-profit-after-tax'));

    totalRevenue.forEach(item => {
      revenue.push(item.innerHTML);
    })

    totalFullyLoadedCost.forEach(item => {
      fullyLoadedCost.push(item.innerHTML);
    })

    totalUnloadedCost.forEach(item => {
      unloadedCost.push(item.innerHTML);
    })

    totalExternalCost.forEach(item => {
      externalCost.push(item.innerHTML);
    })

    sumTotalCost.forEach(item => {
      totalCost.push(item.innerHTML);
    })

    totalProfitBeforeTax.forEach(item => {
      profitBeforeTax.push(item.innerHTML);
    })

    totalProfitNetAfterTax.forEach(item => {
      profitNetAfterTax.push(item.innerHTML);
    })
    
    revenueBreakdown.push(
      revenue, 
      fullyLoadedCost, 
      unloadedCost, 
      externalCost,
      totalCost, 
      profitBeforeTax, 
      profitNetAfterTax 
    )

    this.revenueBreakdown = revenueBreakdown;
  }

  generateExportButton = () => {
    if (!this.showTable) {
      return '';
    }
    let data = this.exportReportHeader;

    if (this.allGroupDetails.length) {
      this.allGroupDetails.forEach(groupDetails => {
        if (groupDetails.length) {
          groupDetails.forEach(item => {
            data.push(item);
          })
        }
        data.push([]);
      })
    }

    if (this.revenueBreakdown.length) {
      data.push([], ['', '', 'Budget', 'Actual', 'Variance', 'Variance%']);
      this.revenueBreakdown.forEach(revenueDetails => {
        if (revenueDetails.length) {
          data.push(revenueDetails);
        }
      })
    }

    return (
      <ExportReport fileName="profitability_per_project" data={data} />
    )
  }

  render() {
    this.renderExportFile();

    return (
      <>
        <PageTitle pageName="Profitability per Project" />
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Row>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                { this.displayProjectDropDown() }
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                { this.displayDatepicker() }
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4} >
                { this.displayGenerateButton() }
              </Col>
            </Row>
          </Col>
        </Row>
        { this.displayProfitabilityReport() }
        <Row className="mt-5">
          <Col>
            { this.generateExportButton() }
          </Col>
        </Row>
      </>
    )
  }
}

export const mapStateToProps = (state) => ({
  projects: state.projects, 
  timesheets: state.timesheets, 
  platforms: state.platforms, 
  reports: state.reports
})

export const mapDispatchToProps = (dispatch) => ({
  getProjectsJSON: (...args) => dispatch(getProjectsJSON(...args)),
  fetchProjects: (...args) =>  dispatch(fetchProjects(...args)),
  getProject: (...args) => dispatch(getProject(...args)),
  fetchPlatforms: () => dispatch(fetchPlatforms()),
  resetProject: () => dispatch(resetProject()),
  fetchProjectScope: (...args) => dispatch(fetchProjectScope(...args)), 
  fetchChildrenProjects: (...args) => dispatch(fetchChildrenProjects(...args)),
  resetTimeEntriesPerProject: () => dispatch(resetTimeEntriesPerProject()),
  refreshReports: () => dispatch(refreshReports()),
  resetAllProjectCosting: () => dispatch(resetAllProjectCosting()),
  toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
  clearApprovedTimeEntries: (...args) => dispatch(clearApprovedTimeEntries(...args))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfitabilityPerProject)